import { render, staticRenderFns } from "./ChapterSetUp.vue?vue&type=template&id=2e1e8074&"
import script from "./ChapterSetUp.vue?vue&type=script&lang=js&"
export * from "./ChapterSetUp.vue?vue&type=script&lang=js&"
import style0 from "./ChapterSetUp.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports